<template>
  <div class="confirmation" v-if="userData">
    <div class="confirmation__hero"></div>
    <div class="confirmation__content">
      <h1 class="confirmation__title">{{ stationData.heading }}</h1>
    </div>
    <div class="confirmation__actions">
      <a class="confirmation__btn-back btn btn--secondary" href="#" @click.prevent="exitStation()">{{ $t('confirmation.toOverview') }}</a>
      <a class="confirmation__btn-next btn" href="#" @click.prevent="proceed">{{ $t('confirmation.terminate') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirmation',
  props: ['userData', 'stationData'],
  mounted() { },
  methods: {
    proceed() {
      this.$emit('navigate', 'Evaluation');
    },
    exitStation() {
      window.postMessage('end');
    }
  },
}
</script>

<style scoped lang="scss">
$heroHeight: 20vh;
$actionHeight: 12rem;

.confirmation {
  height: 100%;
  box-sizing: border-box;
  padding: $heroHeight 5rem 5rem;
}
.confirmation__hero {
  background-color: var(--white);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: $heroHeight;
  z-index: 1;
  text-align: left;
}
.confirmation__content {
  box-sizing: border-box;
  max-width: 40rem;
  height: calc(100% - #{$actionHeight});
  padding: 3rem 0;
  margin: auto;
}
.confirmation__title {
  font-size: 3rem;
  text-align: center;
}
.confirmation__actions {
  height: $actionHeight;
}
.confirmation__btn-back {
  margin-bottom: 2.5rem;
  font-size: 1.7rem;
}
</style>
